/**
 * Preloads every variant's image after the page has loaded, so switching size or framing
 * shows the next image instantly instead of flashing while it downloads.
 * Copies the gallery's own srcset widths and sizes, so the browser fetches the exact file
 * it will use when that variant is picked. Skipped when the visitor has Save-Data on.
 */
const keep = [];

function preload() {
  if (navigator.connection?.saveData) return;
  const data = document.querySelector('script[data-ff-variant-media]');
  const ref = document.querySelector('.product-media img[srcset]');
  if (!data || !ref) return;
  const urls = JSON.parse(data.textContent);
  const candidates = ref.srcset.split(',').map((c) => c.trim().split(/\s+/)).filter((c) => c.length === 2);
  for (const url of urls) {
    const target = new URL(url, location.href);
    const srcset = candidates.map(([src, descriptor]) => {
      const width = new URL(src, location.href).searchParams.get('width');
      const u = new URL(target);
      if (width) u.searchParams.set('width', width);
      return `${u.href} ${descriptor}`;
    });
    const img = new Image();
    img.sizes = ref.sizes;
    img.srcset = srcset.join(', ');
    keep.push(img);
  }
}

const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 3000 }) : setTimeout(fn, 1500));
if (document.readyState === 'complete') idle(preload);
else window.addEventListener('load', () => idle(preload), { once: true });
